module.exports = __webpack_public_path__ + "static/img/MARCOS_CASTRO.eaa2b5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/video-cover/MARCOS_CASTRO.jpg
// module id = AG5z
// module chunks = 1